module.exports = __webpack_public_path__ + "static/operationBlockIdentify-7ec71d58f7ad7fd0e5984e4f207832d1.gif";